export default __webpack_public_path__ + "static/media/SportELS_Posterior.a1e22e43.webp";